import { render, staticRenderFns } from "./ApprenticesDetails.vue?vue&type=template&id=37af37e0&scoped=true&"
import script from "./ApprenticesDetails.vue?vue&type=script&lang=js&"
export * from "./ApprenticesDetails.vue?vue&type=script&lang=js&"
import style0 from "./ApprenticesDetails.vue?vue&type=style&index=0&id=37af37e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37af37e0",
  null
  
)

export default component.exports